<template>
  <component :is="tagName || 'div'" :class="classes">
    <slot></slot>
  </component>
</template>

<script>
import themeMixins from '../../mixins/themeMixins';
export default {
  mixins: [themeMixins],
  props: ['tagName'],
};
</script>
